import React from 'react'
import Link from 'next/link'
import getConfig from 'next/config'

import { style } from '../../components/Contents/Contents.style'
import { style as bkNumStyle } from '../../components/BackNumber/BackNumber.style'
import Page from '../../components/Page/Page'
import Content from '../../components/Content/Content'

const { publicRuntimeConfig } = getConfig()
const basePath = publicRuntimeConfig.basePath

const pageTitle = 'No.159 | 新潟県民だより'

interface OwnProps {
  children: React.ReactNode
}

type Props = OwnProps

const List: React.FC<Props> = (props) => {
  return <ul css={bkNumStyle.bkNumList}>{props.children}</ul>
}

const ListItem = ({
  title,
  href,
  newTab = false,
}: {
  title: string[]
  href: string
  newTab?: boolean
}) => {
  return (
    <li>
      {newTab ? (
        <a
          href={`${basePath}${href}`}
          target="_blank"
          rel="noreferrer"
          css={bkNumStyle.bkNumItem}
        >
          {title.map((txt, i) => {
            return (
              <React.Fragment key={i}>
                {i === 0 ? '' : <br />}
                {txt}
              </React.Fragment>
            )
          })}
        </a>
      ) : (
        <Link href={href} css={bkNumStyle.bkNumItem}>
          {title.map((txt, i) => {
            return (
              <React.Fragment key={i}>
                {i === 0 ? '' : <br />}
                {txt}
              </React.Fragment>
            )
          })}
        </Link>
      )}
    </li>
  )
}

const Contents = () => {
  return (
    <Page title={pageTitle}>
      <Content>
        <img
          src={`${basePath}/no159/img/no159.png`}
          alt="県民だより 初秋号 No.159 特集　2050年 カーボンゼロへ！"
          css={[style.topImg, style.topImgLine]}
        />
        <section css={bkNumStyle.section}>
          <header css={bkNumStyle.sectionHeader}>
            <h3>目次</h3>
          </header>
          <p css={style.listTitle}>特集</p>
          <List>
            <ListItem
              title={['2050年 カーボンゼロへ！']}
              href={'/no159/monthly'}
            />
          </List>
          <p css={style.listTitle}>県からのお知らせ</p>
          <List>
            <ListItem
              title={[
                'デジタル社会のパスポート　マイナンバーカードはこんなに便利！',
              ]}
              href={'/no159/info/01'}
            />
            <ListItem
              title={[
                'にいがた暮らし・しごと支援センター／LINE公式アカウント 新潟Ｕターン情報「YOU TURN」',
              ]}
              href={'/no159/info/02'}
            />
          </List>
          <p css={style.listTitle}>にいがたイベントガイド</p>
          <List>
            <ListItem
              title={['2022お出かけイベント情報']}
              href={'/no159/event'}
            />
          </List>
          <p css={style.listTitle}>みんなで学ぶ連載記事</p>
          <List>
            <ListItem
              title={[
                '「佐渡島（さど）の金山」をフカボリ！―世界遺産登録への道―',
              ]}
              href={'/no159/learn'}
            />
          </List>
          <p css={style.listTitle}>お得情報</p>
          <List>
            <ListItem
              title={['県内のミュージアムをぐるっとお得にめぐりませんか？']}
              href={'/no159/gain'}
            />
          </List>
          <p css={style.listTitle}>
            地域の元気をお届け！地域振興局からのお知らせ
          </p>
          <List>
            <ListItem title={['三条／柏崎／村上']} href={'/no159/area'} />
          </List>
          <p css={style.listTitleNone}></p>
          <List>
            <ListItem title={['読者アンケート']} href={'/no159/regular/01'} />
            <ListItem
              title={['知事と一緒に車座トーク']}
              href={'/no159/regular/02'}
            />
            <ListItem
              title={['たった一人のあなたです　たった一つの命です']}
              href={'/no159/regular/03'}
            />
            <ListItem
              title={['みなさんの声を県政に']}
              href={'/no159/regular/04'}
            />
            <ListItem
              title={['統計で見る！新潟県日本一']}
              href={'/no159/regular/05'}
            />
          </List>
          <p css={[style.listTitle, style.pdfLink]}>PDFで見る</p>
          <List>
            <ListItem
              title={['県民だより 初秋号 No.159（PDF）']}
              href={'/no159/pdf/no159.pdf'}
              newTab={true}
            />
          </List>
        </section>
      </Content>
    </Page>
  )
}
export default Contents
